import { render } from "./WebhooksFiltersEditor.vue?vue&type=template&id=4910a0c4&ts=true"
import script from "./WebhooksFiltersEditor.vue?vue&type=script&lang=ts"
export * from "./WebhooksFiltersEditor.vue?vue&type=script&lang=ts"

import "./WebhooksFiltersEditor.vue?vue&type=style&index=0&id=4910a0c4&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__